import React, { useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Badge, Popover, Tooltip } from 'antd';
import { useCrud } from '@unicus/react-ui-kit';
import NotificationList from './NotificationList';

const MyNotifications = ({ iconClassName = '' }) => {
  const crud = useCrud({
    resource: 'notifications',
    endpoint: 'notifications/my-notifications',
    fixedQueryParams: { onlyIsActive: true }
  });

  const { data, fetch } = crud;

  useEffect(() => {
    if (!data.loaded && !data.loading) {
      fetch();
    }
  }, [data.loaded, data.loading]);

  return (
    <Tooltip title="Notificações">
      <Popover
        openClassName="gx-mynotifications"
        overlayClassName="gx-my-notifications"
        content={() => <NotificationList {...crud} />}
        trigger="click"
      >
        <Badge className="gx-m-0" count={data.notVisualizedCount} size="small">
          <FontAwesomeIcon
            className={`${iconClassName} icon gx-text-white gx-pointer`}
            icon="bell"
          />
        </Badge>
      </Popover>
    </Tooltip>
  );
};

export default MyNotifications;
